import React from 'react';
import { FormattedMessage } from 'react-intl';

const HeaderSinglePaymentSPP = () => (
  <div className="modal-section modal-title text-center divider full blue">
    <div className="header-single-payment-spp">
      <h1>
        <FormattedMessage
          id="autoPilot.header.singlePayment.custom.title"
          defaultMessage="Autopilot"
        />
      </h1>
      <FormattedMessage
        id="autoPilot.header.singlePayment.custom.subtitle"
        defaultMessage="Automatically make your purchase when the goal is met.
          Otherwise, you must return to trigger the purchase manually."
      />
    </div>
  </div>
);

export default HeaderSinglePaymentSPP;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/header.single-payment.spp.js